module.exports = __webpack_public_path__ + "static/media/commission_chart.aecf9161.svg";